import { Observable } from "rxjs";
import { Plant } from "../models/plant";

export abstract class IPlantRepository {
    abstract getAll(): Observable<Plant[]>;
    abstract get(plantId: string): Observable<Plant[]>;
}